
import { Routes, Route } from 'react-router-dom';
import Index from '@/pages/Index';
import MultilingualHomePage from '@/pages/MultilingualHomePage';
import MultilingualSEOManager from '@/pages/MultilingualSEOManager';
import LanguageTestPanel from '@/pages/dev/LanguageTestPanel';
import TranslationAnalysisPage from '@/pages/dev/TranslationAnalysisPage';
import SEOAuditPage from '@/pages/dev/SEOAuditPage';
import CoverageMonitoring from '@/pages/dev/CoverageMonitoring';
import SitemapGenerator from '@/pages/SitemapGenerator';
import CompleteSitemapGenerator from '@/pages/dev/CompleteSitemapGenerator';
import About from '@/pages/About';
import Contact from '@/pages/Contact';
import Find from '@/pages/Find';
import HowItWorks from '@/pages/HowItWorks';
import Pricing from '@/pages/Pricing';
import Specialties from '@/pages/Specialties';
import TherapistProfile from '@/pages/TherapistProfile';
import NotFound from '@/pages/NotFound';
import Directory from '@/pages/Directory';
import AuthPage from '@/pages/auth/AuthPage';
import LocalizedCityLanding from '@/pages/LocalizedCityLanding';
import LocalizedCitySpecialtyLanding from '@/pages/LocalizedCitySpecialtyLanding';
import CityServiceLandingPage from '@/pages/CityServiceLandingPage';
import MultilingualServiceRouter from '@/components/routing/MultilingualServiceRouter';
import ForTherapists from '@/pages/ForTherapists';
import JoseLuisMarin from '@/pages/JoseLuisMarin';
import OnlineTherapy from '@/pages/OnlineTherapy';
import Resources from '@/pages/Resources';
import TherapistFAQ from '@/pages/TherapistFAQ';
import Blog from '@/pages/Blog';
import Privacy from '@/pages/Privacy';
import Terms from '@/pages/Terms';
import Sitemap from '@/pages/Sitemap';
import CookiePolicy from '@/pages/CookiePolicy';
import CountriesListPage from '@/pages/CountriesListPage';
import CountryDirectory from '@/pages/CountryDirectory';
import CountryPsychologists from '@/pages/CountryPsychologists';
import CitiesListPage from '@/pages/CitiesListPage';

//Import new routes
import TherapistPortalRoutes from '@/routes/TherapistPortalRoutes';
import ClientPortalRoutes from '@/routes/ClientPortalRoutes';
import BookingRoutes from '@/routes/BookingRoutes';
import AdminRoutes from '@/routes/AdminRoutes';
import { ClientPortalPage } from '@/pages/ClientPortalPage';
import { TherapistPortalPage } from '@/pages/TherapistPortalPage';
import { EnhancedAuth } from '@/pages/auth/EnhancedAuth';
import CompleteFunctionalityReport from '@/pages/CompleteFunctionalityReport';
import GlobalTranslationEnforcementPage from '@/pages/dev/GlobalTranslationEnforcementPage';
import TranslationExecutionPage from '@/pages/dev/TranslationExecutionPage';
import PhaseBasedTranslationPage from '@/pages/dev/PhaseBasedTranslationPage';
import PortugueseTranslationTestPage from '@/pages/dev/PortugueseTranslationTestPage';
import { MassiveTranslationControl } from '@/pages/dev/MassiveTranslationControl';
import TranslationTemplatesManager from '@/pages/dev/TranslationTemplatesManager';
import Unauthorized from '@/pages/Unauthorized';
import MultilingualPageWrapper from '@/components/routing/MultilingualPageWrapper';
import LayoutWrapper from '@/components/routing/LayoutWrapper';

const MainRoutes = () => {
  return (
    <Routes>
      {/* Unified Auth Routes */}
      <Route path="/auth/*" element={<EnhancedAuth />} />
      <Route path="/login" element={<EnhancedAuth />} />
      <Route path="/signin" element={<EnhancedAuth />} />
      <Route path="/signup" element={<EnhancedAuth />} />
      <Route path="/client-login" element={<EnhancedAuth />} />
      <Route path="/client-signup" element={<EnhancedAuth />} />
      <Route path="/therapist-login" element={<EnhancedAuth />} />
      <Route path="/therapist-signup" element={<EnhancedAuth />} />
      <Route path="/forgot-password" element={<EnhancedAuth />} />
      <Route path="/reset-password" element={<EnhancedAuth />} />
      
      {/* Portal routes */}
      <Route path="/client-portal" element={<ClientPortalPage />} />
      <Route path="/therapist-portal" element={<TherapistPortalPage />} />
      
      {/* Booking routes */}
      <Route path="/book/*" element={<BookingRoutes />} />
      
      {/* Admin routes */}
      <Route path="/admin/*" element={<AdminRoutes />} />
      
      {/* Portal subroutes */}
      <Route path="/client-portal/*" element={<ClientPortalRoutes />} />
      <Route path="/therapist-portal/*" element={<TherapistPortalRoutes />} />
      
      {/* Functionality Report */}
      <Route path="/functionality-report" element={<CompleteFunctionalityReport />} />
      
      {/* Existing routes - English (default) */}
      <Route path="/" element={<LayoutWrapper><Index /></LayoutWrapper>} />
      <Route path="/about" element={<LayoutWrapper><About /></LayoutWrapper>} />
      <Route path="/contact" element={<LayoutWrapper><Contact /></LayoutWrapper>} />
      <Route path="/find" element={<LayoutWrapper><Find /></LayoutWrapper>} />
      <Route path="/how-it-works" element={<LayoutWrapper><HowItWorks /></LayoutWrapper>} />
      <Route path="/pricing" element={<LayoutWrapper><Pricing /></LayoutWrapper>} />
      <Route path="/specialties" element={<LayoutWrapper><Specialties /></LayoutWrapper>} />
      <Route path="/therapist/:id" element={<LayoutWrapper><TherapistProfile /></LayoutWrapper>} />
      <Route path="/for-therapists" element={<LayoutWrapper><ForTherapists /></LayoutWrapper>} />
      <Route path="/jose-luis-marin" element={<LayoutWrapper><JoseLuisMarin /></LayoutWrapper>} />
      <Route path="/resources" element={<LayoutWrapper><Resources /></LayoutWrapper>} />
      <Route path="/therapist-faq" element={<LayoutWrapper><TherapistFAQ /></LayoutWrapper>} />
      <Route path="/blog" element={<LayoutWrapper><Blog /></LayoutWrapper>} />
      <Route path="/online-therapy" element={<LayoutWrapper><OnlineTherapy /></LayoutWrapper>} />
      <Route path="/privacy" element={<LayoutWrapper><Privacy /></LayoutWrapper>} />
      <Route path="/terms" element={<LayoutWrapper><Terms /></LayoutWrapper>} />
      <Route path="/sitemap" element={<LayoutWrapper><Sitemap /></LayoutWrapper>} />
      <Route path="/cookie-policy" element={<LayoutWrapper><CookiePolicy /></LayoutWrapper>} />
      
      {/* Multilingual Static Pages */}
      <Route path="/:lang/about" element={<LayoutWrapper><MultilingualPageWrapper><About /></MultilingualPageWrapper></LayoutWrapper>} />
      <Route path="/:lang/contact" element={<LayoutWrapper><MultilingualPageWrapper><Contact /></MultilingualPageWrapper></LayoutWrapper>} />
      <Route path="/:lang/find" element={<LayoutWrapper><MultilingualPageWrapper><Find /></MultilingualPageWrapper></LayoutWrapper>} />
      <Route path="/:lang/how-it-works" element={<LayoutWrapper><MultilingualPageWrapper><HowItWorks /></MultilingualPageWrapper></LayoutWrapper>} />
      <Route path="/:lang/pricing" element={<LayoutWrapper><MultilingualPageWrapper><Pricing /></MultilingualPageWrapper></LayoutWrapper>} />
      <Route path="/:lang/specialties" element={<LayoutWrapper><MultilingualPageWrapper><Specialties /></MultilingualPageWrapper></LayoutWrapper>} />
      <Route path="/:lang/for-therapists" element={<LayoutWrapper><MultilingualPageWrapper><ForTherapists /></MultilingualPageWrapper></LayoutWrapper>} />
      <Route path="/:lang/jose-luis-marin" element={<LayoutWrapper><MultilingualPageWrapper><JoseLuisMarin /></MultilingualPageWrapper></LayoutWrapper>} />
      <Route path="/:lang/resources" element={<LayoutWrapper><MultilingualPageWrapper><Resources /></MultilingualPageWrapper></LayoutWrapper>} />
      <Route path="/:lang/therapist-faq" element={<LayoutWrapper><MultilingualPageWrapper><TherapistFAQ /></MultilingualPageWrapper></LayoutWrapper>} />
      <Route path="/:lang/blog" element={<LayoutWrapper><MultilingualPageWrapper><Blog /></MultilingualPageWrapper></LayoutWrapper>} />
      <Route path="/:lang/online-therapy" element={<LayoutWrapper><MultilingualPageWrapper><OnlineTherapy /></MultilingualPageWrapper></LayoutWrapper>} />
      <Route path="/:lang/privacy" element={<LayoutWrapper><MultilingualPageWrapper><Privacy /></MultilingualPageWrapper></LayoutWrapper>} />
      <Route path="/:lang/terms" element={<LayoutWrapper><MultilingualPageWrapper><Terms /></MultilingualPageWrapper></LayoutWrapper>} />
      <Route path="/:lang/sitemap" element={<LayoutWrapper><MultilingualPageWrapper><Sitemap /></MultilingualPageWrapper></LayoutWrapper>} />
      <Route path="/:lang/cookie-policy" element={<LayoutWrapper><MultilingualPageWrapper><CookiePolicy /></MultilingualPageWrapper></LayoutWrapper>} />
      
      {/* Dashboard redirect */}
      <Route path="/dashboard/*" element={<EnhancedAuth />} />
      
      {/* Directory routes - English (default) */}
      <Route path="/cities" element={<LayoutWrapper><CitiesListPage /></LayoutWrapper>} />
      <Route path="/countries" element={<LayoutWrapper><CountriesListPage /></LayoutWrapper>} />
      <Route path="/directory" element={<LayoutWrapper><Directory /></LayoutWrapper>} />
      <Route path="/country/:countrySlug" element={<LayoutWrapper><CountryDirectory /></LayoutWrapper>} />
      <Route path="/psychologists/:countrySlug" element={<LayoutWrapper><CountryPsychologists /></LayoutWrapper>} />
      
      {/* City Specialty Landing Pages - SPECIFIC ROUTES FIRST */}
      <Route path="/city/:citySlug/:specialtySlug" element={<LayoutWrapper><LocalizedCitySpecialtyLanding /></LayoutWrapper>} />
      <Route path="/city/:citySlug" element={<LayoutWrapper><LocalizedCityLanding /></LayoutWrapper>} />
      
      {/* Multilingual Directory Pages */}
      <Route path="/:lang/cities" element={<LayoutWrapper><MultilingualPageWrapper><CitiesListPage /></MultilingualPageWrapper></LayoutWrapper>} />
      <Route path="/:lang/countries" element={<LayoutWrapper><MultilingualPageWrapper><CountriesListPage /></MultilingualPageWrapper></LayoutWrapper>} />
      <Route path="/:lang/directory" element={<LayoutWrapper><MultilingualPageWrapper><Directory /></MultilingualPageWrapper></LayoutWrapper>} />
      <Route path="/:lang/country/:countrySlug" element={<LayoutWrapper><MultilingualPageWrapper><CountryDirectory /></MultilingualPageWrapper></LayoutWrapper>} />
      <Route path="/:lang/psychologists/:countrySlug" element={<LayoutWrapper><MultilingualPageWrapper><CountryPsychologists /></MultilingualPageWrapper></LayoutWrapper>} />
      
      {/* Additional redirects */}
      <Route path="/faq" element={<LayoutWrapper><HowItWorks /></LayoutWrapper>} />
      <Route path="/privacy-policy" element={<LayoutWrapper><Privacy /></LayoutWrapper>} />
      <Route path="/terms-of-service" element={<LayoutWrapper><Terms /></LayoutWrapper>} />
      <Route path="/cookies" element={<LayoutWrapper><CookiePolicy /></LayoutWrapper>} />
      
      {/* Multilingual City Specialty Landing Pages - SPECIFIC ROUTES FIRST */}
      <Route path="/:lang/city/:citySlug/:specialtySlug" element={
        <LayoutWrapper>
          <MultilingualPageWrapper>
            <LocalizedCitySpecialtyLanding />
          </MultilingualPageWrapper>
        </LayoutWrapper>
      } />
      
      {/* Language-specific city routes - más específicos */}
      <Route path="/es/city/:citySlug" element={<LayoutWrapper><LocalizedCityLanding /></LayoutWrapper>} />
      <Route path="/fr/city/:citySlug" element={<LayoutWrapper><LocalizedCityLanding /></LayoutWrapper>} />
      <Route path="/de/city/:citySlug" element={<LayoutWrapper><LocalizedCityLanding /></LayoutWrapper>} />
      <Route path="/it/city/:citySlug" element={<LayoutWrapper><LocalizedCityLanding /></LayoutWrapper>} />
      <Route path="/pt/city/:citySlug" element={<LayoutWrapper><LocalizedCityLanding /></LayoutWrapper>} />
      
      {/* Local language routes for cities */}
      <Route path="/ko/city/:citySlug" element={<LayoutWrapper><LocalizedCityLanding /></LayoutWrapper>} />
      <Route path="/ja/city/:citySlug" element={<LayoutWrapper><LocalizedCityLanding /></LayoutWrapper>} />
      <Route path="/zh/city/:citySlug" element={<LayoutWrapper><LocalizedCityLanding /></LayoutWrapper>} />
      <Route path="/ar/city/:citySlug" element={<LayoutWrapper><LocalizedCityLanding /></LayoutWrapper>} />
      <Route path="/hi/city/:citySlug" element={<LayoutWrapper><LocalizedCityLanding /></LayoutWrapper>} />
      <Route path="/ru/city/:citySlug" element={<LayoutWrapper><LocalizedCityLanding /></LayoutWrapper>} />
      <Route path="/tr/city/:citySlug" element={<LayoutWrapper><LocalizedCityLanding /></LayoutWrapper>} />
      <Route path="/th/city/:citySlug" element={<LayoutWrapper><LocalizedCityLanding /></LayoutWrapper>} />
      <Route path="/vi/city/:citySlug" element={<LayoutWrapper><LocalizedCityLanding /></LayoutWrapper>} />
      <Route path="/id/city/:citySlug" element={<LayoutWrapper><LocalizedCityLanding /></LayoutWrapper>} />
      <Route path="/nl/city/:citySlug" element={<LayoutWrapper><LocalizedCityLanding /></LayoutWrapper>} />
      <Route path="/ur/city/:citySlug" element={<LayoutWrapper><LocalizedCityLanding /></LayoutWrapper>} />
      <Route path="/bn/city/:citySlug" element={<LayoutWrapper><LocalizedCityLanding /></LayoutWrapper>} />
      <Route path="/fa/city/:citySlug" element={<LayoutWrapper><LocalizedCityLanding /></LayoutWrapper>} />
      <Route path="/ms/city/:citySlug" element={<LayoutWrapper><LocalizedCityLanding /></LayoutWrapper>} />
      
      {/* General language routes - multilingual homepage */}
      <Route path="/es" element={<LayoutWrapper><MultilingualPageWrapper><MultilingualHomePage /></MultilingualPageWrapper></LayoutWrapper>} />
      <Route path="/fr" element={<LayoutWrapper><MultilingualPageWrapper><MultilingualHomePage /></MultilingualPageWrapper></LayoutWrapper>} />
      <Route path="/de" element={<LayoutWrapper><MultilingualPageWrapper><MultilingualHomePage /></MultilingualPageWrapper></LayoutWrapper>} />
      <Route path="/it" element={<LayoutWrapper><MultilingualPageWrapper><MultilingualHomePage /></MultilingualPageWrapper></LayoutWrapper>} />
      <Route path="/pt" element={<LayoutWrapper><MultilingualPageWrapper><MultilingualHomePage /></MultilingualPageWrapper></LayoutWrapper>} />
      <Route path="/ko" element={<LayoutWrapper><MultilingualPageWrapper><MultilingualHomePage /></MultilingualPageWrapper></LayoutWrapper>} />
      <Route path="/ja" element={<LayoutWrapper><MultilingualPageWrapper><MultilingualHomePage /></MultilingualPageWrapper></LayoutWrapper>} />
      <Route path="/zh" element={<LayoutWrapper><MultilingualPageWrapper><MultilingualHomePage /></MultilingualPageWrapper></LayoutWrapper>} />
      <Route path="/ar" element={<LayoutWrapper><MultilingualPageWrapper><MultilingualHomePage /></MultilingualPageWrapper></LayoutWrapper>} />
      <Route path="/hi" element={<LayoutWrapper><MultilingualPageWrapper><MultilingualHomePage /></MultilingualPageWrapper></LayoutWrapper>} />
      <Route path="/ru" element={<LayoutWrapper><MultilingualPageWrapper><MultilingualHomePage /></MultilingualPageWrapper></LayoutWrapper>} />
      <Route path="/tr" element={<LayoutWrapper><MultilingualPageWrapper><MultilingualHomePage /></MultilingualPageWrapper></LayoutWrapper>} />
      <Route path="/th" element={<LayoutWrapper><MultilingualPageWrapper><MultilingualHomePage /></MultilingualPageWrapper></LayoutWrapper>} />
      <Route path="/vi" element={<LayoutWrapper><MultilingualPageWrapper><MultilingualHomePage /></MultilingualPageWrapper></LayoutWrapper>} />
      <Route path="/id" element={<LayoutWrapper><MultilingualPageWrapper><MultilingualHomePage /></MultilingualPageWrapper></LayoutWrapper>} />
      <Route path="/nl" element={<LayoutWrapper><MultilingualPageWrapper><MultilingualHomePage /></MultilingualPageWrapper></LayoutWrapper>} />
      <Route path="/ur" element={<LayoutWrapper><MultilingualPageWrapper><MultilingualHomePage /></MultilingualPageWrapper></LayoutWrapper>} />
      <Route path="/bn" element={<LayoutWrapper><MultilingualPageWrapper><MultilingualHomePage /></MultilingualPageWrapper></LayoutWrapper>} />
      <Route path="/fa" element={<LayoutWrapper><MultilingualPageWrapper><MultilingualHomePage /></MultilingualPageWrapper></LayoutWrapper>} />
      <Route path="/ms" element={<LayoutWrapper><MultilingualPageWrapper><MultilingualHomePage /></MultilingualPageWrapper></LayoutWrapper>} />
      
      {/* Development tools */}
      <Route path="/dev/translations" element={<TranslationAnalysisPage />} />
      <Route path="/dev/seo-manager" element={<MultilingualSEOManager />} />
      <Route path="/dev/language-test" element={<LanguageTestPanel />} />
      <Route path="/dev/global-enforcement" element={<GlobalTranslationEnforcementPage />} />
      <Route path="/dev/execute-translations" element={<TranslationExecutionPage />} />
      <Route path="/dev/phase-based-translation" element={<PhaseBasedTranslationPage />} />
      <Route path="/dev/portuguese-fix" element={<PortugueseTranslationTestPage />} />
      <Route path="/dev/seo-audit" element={<SEOAuditPage />} />
      <Route path="/dev/coverage-monitoring" element={<CoverageMonitoring />} />
      <Route path="/dev/sitemap-generator" element={<SitemapGenerator />} />
      <Route path="/dev/complete-sitemap" element={<CompleteSitemapGenerator />} />
      <Route path="/dev/massive-translation-control" element={<MassiveTranslationControl />} />
      <Route path="/dev/translation-templates-manager" element={<TranslationTemplatesManager />} />
      
      {/* Unauthorized page */}
      <Route path="/unauthorized" element={<Unauthorized />} />
      
      {/* 404 route */}
      <Route path="*" element={<LayoutWrapper><NotFound /></LayoutWrapper>} />
    </Routes>
  );
};

export default MainRoutes;
